import { Injectable } from '@angular/core'
import { Config } from '../model/config'


const storeKey = 'dfkConfig';

@Injectable()
export class ConfigService {
    private cfg: Config;
    constructor() {
        this.init();
    }
    init() {
        let config = localStorage.getItem(storeKey)
        if (config !== null) {
            this.cfg = JSON.parse(config);
        } else {
            this.cfg = new Config();
            this.save();
        }
    }

    save() {
        localStorage.setItem(storeKey, JSON.stringify(this.cfg));
    }

    get renderJS(): boolean {
        return this.cfg.renderJSContent;
    }

    set renderJS(value: boolean) {
        this.cfg.renderJSContent = value;
    }

    get userToken() {
        return this.cfg.userToken;
    }
}
